<template>
  <svg :style="style" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="BookmarksSimple">
      <path id="Vector"
        d="M15 5.75H6C5.60218 5.75 5.22064 5.90804 4.93934 6.18934C4.65804 6.47064 4.5 6.85218 4.5 7.25V21.5C4.5 21.6378 4.53796 21.7729 4.60972 21.8906C4.68149 22.0082 4.78428 22.1038 4.90681 22.1669C5.02934 22.2299 5.16688 22.258 5.30432 22.248C5.44177 22.2381 5.5738 22.1904 5.68594 22.1103L10.5 18.6716L15.315 22.1103C15.4271 22.1901 15.5591 22.2376 15.6964 22.2474C15.8337 22.2573 15.971 22.2291 16.0934 22.1661C16.2158 22.1031 16.3184 22.0076 16.3902 21.8901C16.4619 21.7726 16.4999 21.6377 16.5 21.5V7.25C16.5 6.85218 16.342 6.47064 16.0607 6.18934C15.7794 5.90804 15.3978 5.75 15 5.75Z"
        fill="white" />
      <path id="Vector_2"
        d="M18 2.75H8.25C8.05109 2.75 7.86032 2.82902 7.71967 2.96967C7.57902 3.11032 7.5 3.30109 7.5 3.5C7.5 3.69891 7.57902 3.88968 7.71967 4.03033C7.86032 4.17098 8.05109 4.25 8.25 4.25H18V18.5C18 18.6989 18.079 18.8897 18.2197 19.0303C18.3603 19.171 18.5511 19.25 18.75 19.25C18.9489 19.25 19.1397 19.171 19.2803 19.0303C19.421 18.8897 19.5 18.6989 19.5 18.5V4.25C19.5 3.85218 19.342 3.47064 19.0607 3.18934C18.7794 2.90804 18.3978 2.75 18 2.75Z"
        fill="white" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'specialist-module',
  props: {
    color: {
      type: String,
      default: 'white'//#212227
    },
    fontSize: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        'vertical-align': 'middle',
        overflow: 'hidden',
        width: '1em',
        height: '1em',
        'font-size': this.fontSize
      }
    }
  }
}
</script>